import { resourceMap } from "./resourceMap";

export const getResource = (resources: Record<string, any> | undefined, key: string, ...args:any[]): string => {
    //NOTE: Grabbing the state directly bypasses React methodology and will not work on the fly. 
    //      Reccommend refactoring so the state is passed in as a parameter...
    if (resources) {
        const resource = resources[key];
        if (typeof resource === 'function') {
            return resource(...args);
        } else if (typeof resource === 'string') {
            return resource;
        } else if (resourceMap["en_us"][key]) {
            const fallback = resourceMap["en_us"][key];
            return typeof fallback === 'function' ? fallback(...args) : fallback;
        }
        
        return resources['MISSING_TRANSLATION'];
    }
    else {
        return "loading";
    }
}
